/**
* Created by kongwm.kong on 2017/8/1.
*/
<template>
    <div :class="['page-side-wrap', {'mtop':!isShowFlag}]">
        <ul class="side-ul">
            <li>
                <div :class="{'icon-wrap': true}" @mouseenter="showIcon1=true; showIcon2=false;">
                    <div class="group">
                        <div class="icon-div"></div>
                        <div class="text">财富APP</div>
                    </div>
                </div>
                <div  ref="showIcon1" :class="{'ps-show': true, 'show': showIcon1}">
                    <img src="../../assets/img/side/code.png">
                    <p class="txt">小金掌上私募</p>
                </div>
            </li>
            <li>
                <div :class="{'icon-wrap': true}" @mouseenter="showIcon1=false; showIcon2=true;">
                    <div class="group">
                        <div class="icon-div"></div>
                        <div class="text">联系我们</div>
                    </div>
                </div>
                <div  ref="showIcon2"  :class="{'ps-show': true, 'show': showIcon2}">
                    请发送邮件至：<br>
                    data@jfz.com
                    <div class="sanjiao"></div>
                </div>
            </li>
            <li v-show="false">
                <div class="icon-wrap">
                    <div class="group">
                        <div class="icon-div"></div>
                        <div class="text">意见反馈</div>
                    </div>
                </div>
                <div class="ps-show">
                    请联系：杨经理<br>
                    邮箱：<br>
                  jason.yang@jfz.com
                    <div class="sanjiao"></div>
                </div>
            </li>
            <li v-show="isShowFlag" @click="goTop">
                <div class="icon-wrap">
                    <div class="group">
                        <div class="icon-div"></div>
                        <div class="text">返回顶部</div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
  export default {
    data(){
      return {
        offTop: 0,
        isShowFlag: false,
        showIcon1: false,
        showIcon2: false,
      }
    },
    mounted(){
      this.isShow();
      this.$nextTick(()=>{
        document.addEventListener('click', (e)=>{
          if(!this.$refs.showIcon1.contains(e.target)){
            this.showIcon1 = false
          }
          if(!this.$refs.showIcon2.contains(e.target)){
            this.showIcon2 = false
          }
        })
      })

    },

    methods: {
      isShow(){
        let h = $(window).height();
        window.onscroll = () => {
          let t = document.documentElement.scrollTop || document.body.scrollTop;
          this.isShowFlag = h < t;
        };

      },
      goTop(){
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        $("body,html").animate({
          scrollTop: 0
        }, scrollTop / 4, 'linear');
        this.isShowFlag = false;
      }
    }
  }
</script>
<style lang="scss" type="text/scss" scoped>
    .page-side-wrap {
        position: fixed;
        z-index: 999;
        right: 10px;
        bottom: 10px;
        &.mtop {
            bottom: 50px;
        }
        .side-ul {

            li {
                margin-top: 3px;
                width: 40px;
                height: 40px;
                cursor: pointer;
                position: relative;
                &:hover {
                    .icon-wrap {
                        .group {
                            transform: translateY(-40px);
                        }
                    }
                }
                .ps-show {
                    position: absolute;
                    right: 45px;
                    padding: 9px 14px;
                    background: $btn_ffa;
                    top: 0;
                    text-align: center;
                    display: none;
                    color: #fff;
                    font-size: 12px;
                    line-height: 16px;
                    letter-spacing: -0.29px;
                    &.show {
                        display: block;
                    }
                    .txt {
                        line-height: 16px;
                        letter-spacing: -0.29px;
                    }
                    .sanjiao {
                        position: absolute;
                        top: 50px;
                        right: -6px;
                        width: 0;
                        height: 6px;
                        border-left: 6px solid $btn_ffa;
                        border-top: transparent 5px solid;
                        border-bottom: transparent 5px solid;;
                    }
                }
                &:nth-child(2) {
                    .icon-wrap {
                        .icon-div {
                            background-image: url(../../assets/img/side/icon0.png);
                        }
                    }
                    .ps-show {
                        right: 51px;
                        top: -22px;
                        width: 110px;
                        text-align: left;
                        padding: 12px 10px;
                        .sanjiao {
                            top: 40px;
                        }
                    }
                }
                &:nth-child(3) {
                    .icon-wrap {
                        .icon-div {
                            background-image: url(../../assets/img/side/icon2.png);
                        }
                    }
                    .ps-show {
                        right: 51px;
                        top: -33px;
                        text-align: left;
                        padding: 20px 10px;
                    }
                }
                &:nth-child(4) {
                    .icon-wrap {
                        .icon-div {
                            background-image: url(../../assets/img/side/top.png);
                        }
                    }
                }

                .icon-wrap {
                    height: 100%;
                    overflow: hidden;
                    .group {
                        height: 100%;
                        transition: all .2s linear;
                    }
                    .icon-div {
                        height: 100%;
                        background-image: url(../../assets/img/side/icon1.png);
                        background-position: center center;
                        background-repeat: no-repeat;
                        background-color: $btn_408;
                    }
                    .text {
                        height: 100%;
                        background-color: $btn_ffa;
                        color: #fff;
                        font-size: 14px;
                        letter-spacing: -0.34px;
                        line-height: 16px;
                        padding: 6px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/pageSide.vue